<template>
  <div
    v-if="lessonStep"
    :class="{ LessonStepContentTile: true, 'LessonStepContentTile--small': $mq === 'mobile' }"
  >
    <div class="Background" :style="{ 'background-image': background }" />

    <div class="Panel">
      <div :class="['mobile', 'tablet'].includes($mq) ? 'TitleMobile' : 'Title'">{{ lessonStep.title }}</div>
    </div>
  </div>
</template>

<script>
import _get from 'lodash/get'

export default {
  name: 'LessonStepContentTile',
  props: {
    lessonStepId: {
      type: String,
      required: true
    }
  },
  computed: {
    lessonStep() {
      return _get(this.$store.state, `lesson.lessonStep.byId.${this.lessonStepId}`)
    },
    background() {
      const lessonWithImage = this.lessonStep.lessons
        .map(id => _get(this.$store.state, `lesson.lesson.byId.${id}`))
        .find(lesson => lesson.tileImage)

      return `url(${this.lessonStep.tileImage || (lessonWithImage && lessonWithImage.tileImage)})`
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.LessonStepContentTile {
  position: relative;
  display: block;
  margin-bottom: 20px;
  border-radius: 20px;
  overflow: hidden;
  height: 250px;

  .Background {
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.33);
    background-repeat: no-repeat;
    background-size: cover;
    background-position-y: -50px;
  }

  .Panel {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: $primary-alt;
    padding: 20px;
    text-align: center;

    .TitleMobile {
      font-size: x-small;
    }
  }

  &--mobile {
    height: 125px;
  }
}
</style>
